<template>
  <el-container class="container">
    <el-aside :style="defaultHeight" :width="asideWidth">
      <el-affix :z-index="1200">
        <div class="aside-logo" @click="onRefresh">
            <i class="el-icon-platform-eleme"></i>   
          <span :class="[isCollapse ? 'is-collapse' : '']">
            <span>支付配置管理</span>
          </span>
        </div>
      </el-affix>
      <el-menu
        class="aside-menu"
        router
        :default-active="$route.path"
        :collapse="isCollapse"
        background-color="#001529"
        text-color="#fff"
        active-text-color="#fff"
      >
        <div v-for="menu in navData" :key="menu">
          <el-menu-item
            v-if="menu.children && menu.children.length === 1"
            :index="menu.children[0].path"
          >
            <i :class="menu.children[0].icon"></i>
            <template #title>{{menu.children[0].name}}</template>
          </el-menu-item>
          <el-submenu v-else-if="menu.children" :index="menu.path">
            <template #title>
              <i :class="menu.icon"></i>
              <span :class="[isCollapse ? 'is-collapse' : '']">{{menu.name}}</span>
            </template>
            <el-menu-item v-for="child in menu.children" :key="child" :index="child.path">
              <i :class="child.icon"></i>
              <template #title>{{child.name}}</template>
            </el-menu-item>
          </el-submenu>
        </div>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header>
        <el-row :gutter="20">
          <el-col :span="1">
            <div class="header-collapse" @click="onCollapse">
              <i :class="[isCollapse ? 'el-icon-s-fold':'el-icon-s-unfold']" />
            </div>
          </el-col>
          <el-col :span="10">
            <div class="header-breadcrumb">
              <el-breadcrumb separator="/" v-if="this.$route.matched[0].path != '/main'">
                <el-breadcrumb-item :to="{ path: '/' }">工作台</el-breadcrumb-item>
                <el-breadcrumb-item
                  v-for="(matched,m) in this.$route.matched"
                  :key="m"
                >{{matched.name}}</el-breadcrumb-item>
              </el-breadcrumb>
              <el-breadcrumb separator="/" v-else>
                <el-breadcrumb-item>工作台</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
          </el-col>
          <el-col class="header-menu" :span="13">
            <HeadMenu></HeadMenu>
          </el-col>
        </el-row>
      </el-header>
      <el-main :style="defaultHeight">
        <router-view />
      </el-main>
    </el-container>
    <el-backtop target=".el-main"></el-backtop>
  </el-container>
</template>
<script>
import { onBeforeMount, reactive, toRefs } from "vue";
import { useRouter } from "vue-router";
import HeadMenu from "@/components/HeadMenu";
import { listcate } from "../api/serviceApi";
export default {
  components: {
    HeadMenu
  },
  data() {
    return {
      navData: []
    };
  },
  methods: {
    getNavData() {
      listcate().then(res => {
        this.navData = res.data;
        //  let arr=[]
        //   res.data.forEach((item)=>{
        //       item.icon='el-icon-menu'
        //       if(item.auth==1){
        //         arr['name']=item.name
        //         item.children.forEach((it)=>{
        //             if(it.auth){
        //                 arr['children'][]['name']=it.name
        //             }
        //         })
        //       }
        //   })
        //   console.log(arr)
        for (let key of this.navData) {
          this.forListFn(key.children);
        }

        this.navData.unshift({
          path: "/main",
          icon: "el-icon-s-home",
          meta: { title: "工作台", requireAuth: true },
          redirect: "/home",
          children: [
            {
              path: "/home",
              name: "工作台",
              icon: "el-icon-s-home",
              meta: { title: "工作台", requireAuth: true }
            }
          ]
        });
      });
    },
    forListFn(data) {
      for (let i = 0; i < data.length; i++) {
        //console.log(data[i].children)
        if (data[i].children != undefined && data[i].children.length > 0) {
          //   let name = data[i].name;
          let list = [];
          for (let b = 0; b < data[i].children.length; b++) {
            //   if(data[i].children[b].name!='收款主体启用'){
            list.push(data[i].children[b].name);
            //   }
          }
          sessionStorage.setItem(data[i].name, list);
          // console.log(name, list);
        }
      }
    }
  },
  created() {
    this.getNavData();
  },
  setup() {
    const router = useRouter();
    const state = reactive({
      isCollapse: false,
      asideWidth: "220px",
      defaultHeight: {
        height: ""
      }
      // routers: [],
    });

    onBeforeMount(() => {
      // state.routers = router.options.routes
      state.defaultHeight.height = document.body.clientHeight + "px";
    });

    const onCollapse = () => {
      if (state.isCollapse) {
        state.asideWidth = "220px";
        state.isCollapse = false;
      } else {
        state.isCollapse = true;
        state.asideWidth = "64px";
      }
    };

    const onRefresh = () => {
      router.push({ path: "/main" });
    };

    return {
      ...toRefs(state),
      onCollapse,
      onRefresh
    };
  }
};
</script>
<style lang="less">
.container {
  background: rgb(245, 247, 249);
  .el-aside {
    height: 100%;
    transition: all 0.5s;
    background-color: #001529;
    overflow-y: auto;
    overflow-x: hidden;

    .aside-logo {
      height: 59px;
      color: white;
      cursor: pointer;
      border-bottom: 1px #cccccc solid;
      text-align: center;
      line-height: 59px;
      .logo-image {
        width: 40px;
        height: 40px;
        top: 12px;
        padding-left: 12px;
      }
      .logo-name {
        font-size: 20px;
        font-weight: bold;
        padding: 2px;
      }
    }
    .aside-menu:not(.el-menu--collapse) {
      width: 220px;
      .el-menu-item.is-active {
        background-color: #d9393b !important;
      }
    }
    .is-collapse {
      display: none;
    }
  }

  .el-aside::-webkit-scrollbar {
    width: 0px;
  }

  .el-header {
    background: white;
    line-height: 60px;
    font-size: 24px;
    border-bottom: 1px #cccccc solid;
    .header-collapse {
      cursor: pointer;
    }
    .header-breadcrumb {
      padding-top: 0.9em;
    }
    .header-menu {
      text-align: right;
    }
  }
  .el-main {
    height: 100%;
    padding-bottom: 100px;
  }
}
</style>